/**
 * mulberry32-подобный детерминированный rng из концепта — для ВИЗУАЛЬНОЙ
 * вариативности (формы blob-платформ, процедурные текстуры), не для ленты эфира
 * (та живёт в Rust/WASM). Порт 1:1, чтобы вид совпадал с концептом.
 */
export function rng(seed: number): () => number {
  let t = seed >>> 0;
  return () => {
    t += 0x6d2b79f5;
    let x = Math.imul(t ^ (t >>> 15), 1 | t);
    x ^= x + Math.imul(x ^ (x >>> 7), 61 | x);
    return ((x ^ (x >>> 14)) >>> 0) / 4294967296;
  };
}
